import React from 'react'
import CTA from './cta';
import './header.css';
import Me from '../../assets/Me-circle.png'
import Socials from '../shared/socials';
// import Summary from '../summary/summary'

const header = () => {
    return (
        <section>
            {/* <Summary /> */}
            <header>
                <div className='container header__container'>
                    <h5>Hello I'm</h5>
                    <h1>
                        <a target="_blank" rel="noreferrer" style={{color: "#fff"}} className="badge-base__link LI-simple-link" href="https://in.linkedin.com/in/bhuwan-pandey?trk=profile-badge">
                            Bhuwan Pandey
                        </a>
                    </h1>
                    <h6 className='header__summary'>Microsoft Certified CSS3, HTML5 and JavaScript Developer</h6>
                    <CTA />
                    <div className='me'>
                        <img src={Me} width={400} height={400} alt="Bhuwan Pandey" />
                    </div>
                    <Socials classToApply={"header__socials"} />
                    <a href="#contact" className='scroll__down'>Scroll Down</a>
                </div>
            </header>
        </section >
    )
}

export default header